$(() => {
  fancyBoxJquery("[data-fancybox]").fancybox({
    video: {
      tpl:
        '<video class="fancybox-video" controls controlsList="nodownload">' +
        '<source src="{{src}}" type="{{format}}" />' +
        'Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!' +
        "</video>",
    },
  });
  // leadership blurb clicked function add class for custom popup
  $('.bs-section--leadership-executive-team a[data-fancybox="true"]').each((index, element) => {
    $(element).attr("data-auto-focus", "false");
    $(element).on("click", (e) => {
      if ($(".fancybox-content").length) {
        $(".fancybox-container").addClass("leadership-popup");
      }
    });
  });
});
